import React, { useEffect, useState } from "react";
import { JobBankService } from "../../services/jobBank.service";
import {Button} from "antd";
import classNames from 'classnames';

export function AsideCategoriesJobs ({setFilters, filters}) {
  const [categories, setCategories] = useState([]);

    const handleFilter = (filter) => {
        if (filters.popularFilter === filter) {
            setFilters({ ...filters, popularFilter: "" });
        } else {
            setFilters({ ...filters, popularFilter: filter });
        }
    }

    useEffect(() => {
        JobBankService.getCategories().then((result) => {
          setCategories(result.slice(0, 10));
        });
    }, [])

    return (
    <aside className="job-bank-categories">
      <h5>Búsquedas populares</h5>
      <ul className="job-bank-categories-content">
        {categories.map((category, i) => (
            <li key={i}>
                <Button
                    size="small"
                    key={i}
                    className={classNames({ active: filters.popularFilter === category.name })}
                    onClick={() => handleFilter(category.name)}
                >
                    {category.name}
                </Button>
            </li>
        ))}
      </ul>
    </aside>
  );
}